import api from './api';
import { Grupo } from './grupoService';

export interface Comunidade extends Grupo {
  totalGruposVinculados?: number;
  gruposVinculados?: Grupo[];
}

export type AcaoComunidadeGrupo = 'add' | 'remove';

export const comunidadeService = {
  listar: (params?: { instanciaUazapiId?: string; search?: string; page?: number; pageSize?: number }) =>
    api.get('/comunidades', { params }),

  criar: (data: { instanciaUazapiId: string; nome: string }) =>
    api.post('/comunidades', data),

  obter: (id: string) =>
    api.get(`/comunidades/${id}`),

  gerenciarGrupos: (id: string, action: AcaoComunidadeGrupo, grupoIds: string[]) =>
    api.post(`/comunidades/${id}/grupos`, { action, grupoIds }),
};
